//#region Util Imports

import * as $ from 'jquery'
import * as _ from 'underscore'

//#endregion


import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Dictionary } from '../../helpers'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDataList } from '../util/op-data-list'
import { TypeHelper } from '../../helpers/type-helper'
import { OpDataType } from './op-data-type'
import { OpDescr } from './op-descr'
import { OpProfileData } from './op-profile-data'

export class OpProfile implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idProfile: number
    public name: string
    public idDescr: number
    public idModule: number
    public descr: OpDescr

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //Custom properties
    public parameters: OpDataList<OpProfileData> = new OpDataList<OpProfileData>()

    public get configurationCode(): number {
        if (this.parameters && this.parameters.length > 0) {
            return this.parameters.getValue(Enums.DataType.PROFILE_CONFIGURATION_CODE, 0, null)
        }

        return null
    }
    public set configurationCode(value: number) {
        if (this.parameters) {
            this.parameters.setValue(value, Enums.DataType.PROFILE_CONFIGURATION_CODE, 0)
        }
    }
    //Custom properties end

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdProfile
    }
    public getReferenceKey(): number {
        return this.idProfile
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.idProfile = opObj.IP
                this.name = opObj.N
                this.idModule = opObj.IM
                this.idDescr = opObj.I
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O

                this.parameters = new OpDataList<OpProfileData>()

                if (opObj.P) {
                    this.parameters.push(...opObj.P.map((data: any) => new OpProfileData(data)))
                }
            } else {
                this.idProfile = opObj.ID_PROFILE
                this.name = opObj.NAME
                this.idModule = opObj.ID_MODULE
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState

                this.parameters = new OpDataList<OpProfileData>()

                if (opObj.Parameters) {
                    this.parameters.push(...opObj.Parameters.map((data: any) => new OpProfileData(data)))
                }
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                IP: this.idProfile,
                N: this.name,
                IM: this.idModule,
                I: this.idDescr,
                D: this.descr != null ? this.descr.toJSON(compressed) : null,
                O: this.opState,
                P: this.parameters != null ? this.parameters.ToJSON(compressed) : null,
            }

            TypeHelper.setJSONCompressedFlag(result);
            TypeHelper.deleteNulls(result);

            return result;
        }

        return {
            ID_PROFILE: this.idProfile,
            NAME: this.name,
            ID_MODULE: this.idModule,
            ID_DESCR: this.idDescr,
            _Descr: this.descr != null ? this.descr.toJSON(compressed) : null,
            Parameters: this.parameters != null ? this.parameters.ToJSON(false) : null,
            OpState: this.opState
        }
    }

    public toString() {
        return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpProfile[]): JQueryPromise<OpProfile[]> {
        const deferred = $.Deferred<OpProfile[]>()

        if (dataProvider != null && _.isArray(list)) {
            dataProvider
                .System
                .getDictionaries([Enums.ReferenceType.IdDataType])
                .then((dict: Dictionary<Dictionary<IReferenceType>>) => {
                    let dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                    if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                        dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                    }

                    list.forEach((item: OpProfile) => {
                        if (item.parameters != null) {
                            item
                                .parameters
                                .toArray()
                                .forEach((profileData: OpProfileData) => {
                                    profileData.dataType = dataTypeDict.tryGetValue(profileData.idDataType)
                                })
                        }
                    })

                    deferred.resolve(list)
                })
        }

        return deferred.promise()
    }
}